import styled from 'styled-components';
import { Typography } from 'design-system/src/components/Typography/Typography';
import { LongLogoLink } from 'design-system/src/components/Logo/LongLogoLink';
import { TopNavbar as DesignSystemTopNavbar } from 'design-system/src/components/TopNavbar';

// Note: As of writing, this file is identical to the one in pharma-portal

const TertiaryButtonLink = styled.a`
  text-decoration: none;
  display: flex;
  height: 2.25rem;
  justify-content: center;
  align-items: center;
  padding: 0px 1rem;
  color: var(--grayscale-900);
  font-weight: 500;
`;

const PrimaryButtonLink = styled(TertiaryButtonLink)`
  // Using && to increase CSS specificity when extending a styled component.
  // This ensures these style overrides take precedence over the base TertiaryButtonLink styles
  // without needing !important, which is more maintainable.
  && {
    border-radius: 10px;
    color: var(--white);
    background: var(--purple-700);

    /* Body/Semibold */
    font-size: 15px;
    font-weight: 600;
    line-height: 20px; /* 133.333% */
    letter-spacing: 0.15px;
  }
`;

const Pipe = styled.div`
  width: 1px;
  background-color: rgba(0, 0, 0, 0.2);
  height: 20px;

  @media screen and (max-width: 768px) {
    display: none;
  }
`;

const ButtonLinkDesktopOnly = styled(TertiaryButtonLink)`
  @media screen and (max-width: 768px) {
    display: none;
  }
`;

/**
 * Bar that sits on top of the logged-out homepage
 */
export const TopNavbar = () => {
  return (
    <DesignSystemTopNavbar
      leftNavbarSection={<LongLogoLink />}
      rightNavbarSection={
        <>
          <ButtonLinkDesktopOnly href="https://www.withtandem.com/patients">
            <Typography renderedAs="span" weight={500}>
              Patients
            </Typography>
          </ButtonLinkDesktopOnly>
          <ButtonLinkDesktopOnly href="https://www.withtandem.com">
            <Typography renderedAs="span" weight={500}>
              Doctors
            </Typography>
          </ButtonLinkDesktopOnly>

          <Pipe />

          <TertiaryButtonLink href="/login">
            <Typography renderedAs="span" weight={500}>
              Log in
            </Typography>
          </TertiaryButtonLink>
          <PrimaryButtonLink href="/signup">Sign up</PrimaryButtonLink>
        </>
      }
    />
  );
};
